import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import CategoriesCard from '../Sidebar/components/CategoriesCard';
import TagsCard from '../Sidebar/components/TagsCard';
import PublishCard from '../Sidebar/components/PublishCard';
import FeaturedImageCard from '../Sidebar/components/FeaturedImageCard';

class Sidebar extends Component {

  render() {
    return (
      <Row>
        <Col md={6} lg={12}>
          <CategoriesCard {...this.props} />
        </Col>
        <Col md={6} lg={12}>
          <TagsCard {...this.props} />
        </Col>
        <Col md={12} lg={12}>
          <FeaturedImageCard {...this.props} />
        </Col>
        <Col md={12} lg={12}>
          <PublishCard {...this.props} />
        </Col>
      </Row>
    )
  }
}

export default Sidebar;
